module.exports = __webpack_public_path__ + "img/phone_added.1e3ab762.svg";